'use client';

import { Button } from '@/app/components/button';
import { IconMyLocation } from '@/app/components/icons/maps/icon-my-location';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

export interface MapControlsMobileProps {
  onClickCurrentLocation: () => void;
}

export const MapControlsMobile = ({
  onClickCurrentLocation,
}: MapControlsMobileProps) => {
  return (
    <Button
      onClick={onClickCurrentLocation}
      color="black"
      aria-label="Current Location"
      iconBefore={<IconMyLocation />}
      size="sm"
      className="absolute -top-12 right-4 xl:hidden"
      {...createDataAttributes({ test: 'current-location' })}
    />
  );
};
